var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42005 1.80437H4.57769C4.40902 1.80437 4.27148 1.66683 4.27148 1.49816V0.306206C4.27148 0.136668 4.40902 0 4.57769 0H7.42005C7.58872 0 7.72625 0.136668 7.72625 0.306206V1.49816C7.72625 1.66683 7.58872 1.80437 7.42005 1.80437Z",
    fill: "#8F95AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45642 15.8736H3.54241C2.79679 15.8736 2.1913 15.2689 2.1913 14.5225L0.691406 2.37542C0.691406 1.62807 1.2969 1.02344 2.04252 1.02344H9.95631C10.7028 1.02344 11.3083 1.62807 11.3083 2.37542L9.80753 14.5225C9.80753 15.2689 9.2029 15.8736 8.45642 15.8736Z",
    fill: "#8F95AC",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5061 3.88223H0.493909C0.220572 3.88223 0 3.66079 0 3.38832V1.51821C0 1.24487 0.220572 1.02344 0.493909 1.02344H11.5061C11.7786 1.02344 12 1.24487 12 1.51821V3.38832C12 3.66079 11.7786 3.88223 11.5061 3.88223Z",
    fill: "#8F95AC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5161d499.svg";
export { ForwardRef as ReactComponent };